import { REDUX_STORE } from '@funnels/constants';
import {
  APPLICATION_DATA_COLLECTION_STATUS,
  ApplicationDataCollectionReducerState,
  ApplicationDataCollectionActionTypes,
} from '@funnels/types';

const initialState: ApplicationDataCollectionReducerState = {
  status: APPLICATION_DATA_COLLECTION_STATUS.INIT,
  error: null,
};

export default function applicationDataCollectionReducer(
  state: ApplicationDataCollectionReducerState = initialState,
  action: ApplicationDataCollectionActionTypes
): ApplicationDataCollectionReducerState {
  switch (action.type) {
    case REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION:
      return {
        status: APPLICATION_DATA_COLLECTION_STATUS.PENDING,
        error: null,
      };
    case REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_SUCCESS:
      return {
        status: APPLICATION_DATA_COLLECTION_STATUS.SUCCESS,
        error: null,
      };
    case REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_FAILED:
      return {
        status: APPLICATION_DATA_COLLECTION_STATUS.ERROR,
        error: action.error,
      };
    default:
      return state;
  }
}
